import React from 'react';
import PropTypes from 'prop-types';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { withStyles } from '@mui/styles';
import TableSortLabel from '@mui/material/TableSortLabel';
import Tooltip from '@mui/material/Tooltip';
import { withTranslation } from 'react-i18next';

class EnhancedTableHead extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  createSortHandler = (property, field) => event => {
      this.props.onRequestSort(event, property, field);
  };

  render() {
    const {
      order,
      orderBy,
      sortId,
      t
    } = this.props;
    const rows = [
      {
        id: 'store',
        numeric: false,
        disablePadding: false,
        label: t("Report.KioskUtil.Store"),
        padding: '10px',
        field: 'name'
      },
      {
        id: 'box',
        numeric: false,
        disablePadding: false,
        label: t("Report.KioskUtil.Box"),
        padding: '10px',
        field: 'name'
      },
      {
        id: 'totalbins',
        numeric: false,
        disablePadding: false,
        label: t("Report.KioskUtil.TotalBins"),
        padding: '10px',
        field: 'total_bins'
      },
      {
        id: 'availablebins',
        numeric: false,
        disablePadding: false,
        label: t("Report.KioskUtil.AvailableBins"),
        padding: '10px',
        field: 'available_bins'
      },
      {
        id: 'useBins',
        numeric: false,
        disablePadding: false,
        label: t("Report.KioskUtil.UsedBins"),
        padding: '10px',
        field: 'use_bins'
      },
      {
        id: 'stockedbins',
        numeric: false,
        disablePadding: false,
        label: t("Report.KioskUtil.StockedBins"),
        padding: '10px',
        field: 'stock_bins'
      },
      {
        id: 'utilization',
        numeric: false,
        disablePadding: false,
        label: t("Report.KioskUtil.Utilization"),
        padding: '10px',
        field: 'box_utilization'
      },
      {
        id: 'date',
        numeric: false,
        disablePadding: false,
        label: t("Report.KioskUtil.Date"),
        padding: '10px',
        field: 'utilization_date'
      }
    ];
    return (
      <React.Fragment>
        <TableHead>
          <TableRow>
            {rows.map((row) => {
              return (
                <TableCell
                  key={row.id}
                  numeric={row.numeric}
                  padding={"none"}
                  sortDirection={orderBy === row.field ? order : false}
                  style={{padding:row.padding, color: 'rgba(0, 0, 0, 0.54)'}}
                >
                {['totalbins', 'availablebins', 'useBins', 'stockedbins'].includes(row.id) ?
                  (<TableSortLabel style={{ cursor: 'text' }}>
                      {row.label}
                    </TableSortLabel>
                   ) : (
                    <Tooltip
                      title={t("Global.Label.Filter.Sort")}
                      placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                      enterDelay={300}>
                      <TableSortLabel
                        active={orderBy === row.field && sortId === row.id}
                        direction={order}
                        onClick={this.createSortHandler(row.id, row.field)}>
                        {row.label}
                      </TableSortLabel>
                    </Tooltip>
                  )}
                </TableCell>
              );
            }, this)}
          </TableRow>
        </TableHead>
      </React.Fragment>
    );
  }
}

EnhancedTableHead.propTypes = {
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  onRequestSort: PropTypes.func.isRequired
};

export default withStyles()(withTranslation()(EnhancedTableHead));



// WEBPACK FOOTER //
// ./src/components/reports/kiosk-box-utilization/EnhancedTableHead.index.js